import React from "react";
import { observer, inject } from "mobx-react";
import { UIStore } from "stores";
import * as styles from "./GlobalMessage.module.scss";
import { useOutsideAlerter } from "src/libs/hooks/useOutsideAlerter";

export interface GlobalMessageProps {
  uiStore?: UIStore;
}

export const GlobalMessage = inject("uiStore")(
  observer(({ uiStore }) => {
    const { globalMessage, globalMessageType, toggleGlobalMessage } = uiStore;
    const containerRef = React.useRef(null);

    useOutsideAlerter(containerRef, () => {
      toggleGlobalMessage();
    });

    if (!globalMessage) {
      return null;
    }
    return (
      <div className={styles[globalMessageType]} ref={containerRef}>
        {globalMessage}
      </div>
    );
  })
);
